import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import styled from 'styled-components'
import 'react-photoswipe/lib/photoswipe.css'
import { PhotoSwipeGallery } from 'react-photoswipe'
import { Pagination } from 'advenio-components'
import StudentPhotosActions from '../../Data/Redux/ParentPlatform/PhotosRedux'

const SectionName = styled.span`
  font-size: 14px;
  color:#a0a0a0;
  text-transform: uppercase;
`

const Page = styled.div`
  padding: 8px;
  border-top: solid 1px;
  border-top-color: #CCCCCC;
`

const PhotosContainer = styled.div`
  .page-info{
    margin-top: 0.6rem;
    display: flex;
    flex-wrap: wrap;

    .text-page{
      margin-left: .5rem;
    }
  }

  .pswp-thumbnails{
    padding: 0.5vw;
    font-size: 0;
    flex-flow: row wrap;
    display: flex;

    div{
      flex: auto;
      width: 150px;
      margin: .5vw;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .pswp__container .pswp__item {
    text-align: center;

    .pswp__zoom-wrap{
      transform: none!important;

      .pswp__img{
        width: auto!important;
        position: relative;
        margin: 0 auto;
      }
    }
  }

  .pswp__caption .pswp__caption__center{
    text-align: center;
  }
`

class Photos extends Component {
  constructor(props) {
    super(props)
    this.state = {
      photos: [],
      pagination: {},
      links: {},
    }

    this.options = {
      shareEl: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
    }
  }

  componentDidMount() {
    const { studentId } = this.props

    if (studentId) {
      this.fetchChildPhotos(studentId)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.photos.meta !== this.state.pagination
      && nextProps.photos.data
      && nextProps.photos.data.length > 0
    ) {
      const photos = []
      nextProps.photos.data.forEach((item) => {
        const formated = {
          src: item.path,
          thumbnail: item.path,
          w: 1200,
          h: 900,
          id: item.id,
          title: moment(item.created_at).format('LLLL'),
          created_at: item.created_at,
        }

        photos.push(formated)
      })

      this.setState({
        photos,
        pagination: nextProps.photos.meta,
        links: nextProps.photos.links,
      })
    }
  }

  getThumbnailContent = item =>
    <img src={item.thumbnail} width={120} height={90} alt={item.title} />

  fetchChildPhotos = (id, page = 1) => {
    this.props.getPhotos(id, page)
  }

  renderPhotosContent = () => {
    const { photos, pagination } = this.state
    const { studentId } = this.props

    if (this.props.loadingPhotos) {
      return (
        <p>Cargando fotos...</p>
      )
    } else if (photos.length > 0) {

      const begin = moment(photos[0].created_at).format('DD-MM-YYYY')
      const end = moment(photos[photos.length - 1].created_at).format('DD-MM-YYYY')

      let showingPhotosFrom = 'Mostrando fotos del '

      if (begin === end) {
        showingPhotosFrom += begin
      } else {
        showingPhotosFrom += begin + ' al ' + end
      }

      return (
        <PhotosContainer>
          <div className="page-info">
            <Pagination
              totalElements={pagination.total}
              elementsPerPage={pagination.per_page}
              onPageClick={number => this.fetchChildPhotos(studentId, number)}
              pageSelected={pagination.current_page}
            />
            <div className="text-page">{showingPhotosFrom}</div>
          </div>

          <PhotoSwipeGallery
            items={photos}
            options={this.options}
            thumbnailContent={this.getThumbnailContent}
          />
        </PhotosContainer>
      )
    }

    return (
      <p>No hay fotos para mostrar.</p>
    )
  }

  render() {
    return (
      <Page>
        <SectionName>Fotos Recientes</SectionName>
        {this.renderPhotosContent()}
      </Page>
    )
  }
}

Photos.propTypes = {
  /** List of validated photos of student */
  photos: PropTypes.object,
  /** Get Id of active child */
  studentId: PropTypes.number.isRequired,
  /** State of request if is fetching photos */
  loadingPhotos: PropTypes.bool,

  /** Fetch a paginated photos of student */
  getPhotos: PropTypes.func.isRequired,
}

Photos.defaultProps = {
  photos: {},
  loadingPhotos: true,
}

const mapStateToProps = state => ({
  photos: state.student_photos.get.results.data,
  loadingPhotos: state.student_photos.get.fetching,
  studentId: state.parent_platform_children.activeChildId,
})

const mapDispatchToProps = dispatch => ({
  getPhotos: (studentId, page) =>
    dispatch(StudentPhotosActions.getStudentPhotosRequest({ studentId, page })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Photos)



// WEBPACK FOOTER //
// ./src/Containers/ParentPlatform/Photos.jsx